import { http } from './http';

export const getProspects = () => {
  return http.get<any>(`prospects`);
};

export const getProspect = (slug: string) => {
  return http.get<any>(`prospects/${slug}`);
};

export const updateProspect = (
  slug: string,
  params: { description?: string; support_needed?: boolean }
) => {
  return http.post<any>(`prospects/${slug}/edit`, params);
};
